module.exports = "<div id=\"page-wrapper\">\n  <ng-container>\n    <div class=\"hazard-fixed-form\" style=\"height: 75vh\">\n      <iframe height=\"100%\" width=\"100%\"  frameborder=\"0\"></iframe>\n    </div>\n    <div class=\"preview-hazard-form\">\n      <button type=\"submit\" class=\"btn save-btn\" (click)=\"close()\"> Done </button>\n    </div>\n  </ng-container>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/rFF/pdf-image-preview/pdf-image-preview.component.html
// module id = ./src/app/rFF/pdf-image-preview/pdf-image-preview.component.html
// module chunks = main